// extracted by mini-css-extract-plugin
module.exports = {"popup":"_2OiIOFkAV-taxS7XPEmLsS","link_wrapper":"_5qcfgECQxcaceqBl8JWBb"};